import { useEffect } from 'react';
import { useRouter } from 'next/router';

export function useCleanHtmlAd() {
    const router = useRouter();

    useEffect(() => {
        const handleRouteChange = () => {
            const htmlElement = document.documentElement;
            // Comprovar l'atribut 'class' i eliminar classes que comencen amb 'ad_'
            const classAttribute = htmlElement.getAttribute('class');
            if (classAttribute) {
                const classes = classAttribute.split(/\s+/);
                const filteredClasses = classes.filter((cls) => !cls.startsWith('ad_'));
                const removedClasses = classes.filter((cls) => cls.startsWith('ad_'));

                if (removedClasses.length > 0) {
                    htmlElement.setAttribute('class', filteredClasses.join(' '));
                }
            }
        };

        // Executar al canviar de ruta
        router.events.on('routeChangeComplete', handleRouteChange);

        return () => {
            router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, [router]);
}
